import { gql } from "@apollo/client"

// Tournament Type Queries
export const TOURNAMENT_TYPE_DETAIL = gql`
  query TournamentType($id: Int!) {
    TournamentType(id: $id) {
      id
      name
      urlImage
      description
      status
      private
      minPlayers
      maxTopPlayers
      multiplier
      winnerPoints
      loserPoints
      drawPoints
      socialRequired
      storeTournaments
      canBeDouble
    }
  }
`

export const TOURNAMENT_TYPE_UPDATE = gql`
  mutation TournamentTypeUpdate($TournamentTypeUpdateInput: TournamentTypeUpdateInput!) {
    TournamentTypeUpdate(input: $TournamentTypeUpdateInput) {
      status {
        success
        name
        detail
      }
      TournamentType {
        id
        name
        description
        sortOrder
        status
        minPlayers
        maxTopPlayers
        multiplier
        winnerPoints
        loserPoints
        drawPoints
        socialRequired
        urlImage
      }
    }
  }
`

// Format Queries
export const FORMAT_DETAIL = gql`
  query Format($id: Int!) {
    Format(id: $id) {
      id
      name
      description
      status
      FormatGames {
        id
        formatId
        gameId
      }
    }
  }
`

export const FORMAT_UPDATE = gql`
  mutation FormatUpdate($FormatUpdateInput: FormatUpdateInput!) {
    FormatUpdate(input: $FormatUpdateInput) {
      status {
        success
        name
        detail
      }
      Format {
        id
        name
        description
        sortOrder
        status
        FormatGames {
          gameId
          formatId
        }
      }
    }
  }
`

// Season Queries
export const SEASON_DETAIL = gql`
  query Season($id: Int!) {
    Season(id: $id) {
      id
      name
      startDate
      endDate
      description
      isActive
      Game {
        id
        name
      }
    }
  }
`

export const SEASON_UPDATE = gql`
  mutation SeasonUpdate($SeasonUpdateInput: SeasonUpdateInput!) {
    SeasonUpdate(input: $SeasonUpdateInput) {
      status {
        success
        name
        detail
      }
      Season {
        id
        name
        description
        isActive
        gameId
        rankingUrl
      }
    }
  }
`

export const SEASON_CREATE = gql`
  mutation SeasonCreate($SeasonCreateInput: SeasonCreateInput!) {
    SeasonCreate(input: $SeasonCreateInput) {
      status {
        success
        name
        detail
      }
      Season {
        id
        name
        rankingUrl
      }
    }
  }
`

// Enhanced allSeasons query for admin
export const ALL_SEASONS_ADMIN = gql`
  query allSeasonsAdmin {
    allSeasons(paginate: 999, orderBy: name_ASC) {
      id
      name
      code
      description
      isActive
      startDate
      endDate
      urlUpdate
      rankingUrl
      totalTournaments
      gameId
      Game {
        id
        name
        sortOrder
        urlImage
      }
    }
  }
`

// Enhanced allFormats query for admin
export const ALL_FORMATS_ADMIN = gql`
  query allFormatsAdmin {
    allFormats(paginate: 999, orderBy: name_ASC) {
      id
      name
      description
      image
      sortOrder
      status
      deckbuilder
      maxCopies
      minDeck
      maxDeck
      sideboard
      extraCards
      urlUpdate
      totalTournaments
      FormatGames {
        gameId
        formatId
        Game {
          id
          name
        }
      }
    }
  }
`

// Game Queries
export const GAME_DETAIL = gql`
  query Game($id: Int!) {
    game(id: $id) {
      id
      name
      description
      urlImage
      sortOrder
      isActive
      totalTournaments
    }
  }
`

export const GAME_UPDATE = gql`
  mutation GameEdit($GameEditInput: GameEditInput!) {
    GameEdit(input: $GameEditInput) {
      status {
        success
        name
        detail
      }
      Game {
        id
        name
        description
        urlImage
        sortOrder
        isActive
      }
    }
  }
`
